module.exports = __webpack_public_path__ + "static/media/r269.c7993a59.jpg";